export default function () {
  return {
    activities: [],
    activity: {},
    activityDetail: {},
    dailyActivities: [],
    dailyActivity: {},
    activityTableSort: {
      sortBy: 'plan_date',
      sortDesc: true
    },
    // daily activity sort
    daSort: {
      sortBy: 'probability_id',
      sortDesc: true
    },

    // daily type
    dailyTypes: [],
    dailyType: {},
    listDailyActivityType: [],

    // action
    actions: [],
    action: {},

    //
    haveCustomer: [],
    haveSales: [],

    // today
    today: {
      tables: [],
      maps: []
    },

    weekly: [],
    salesActivity: [],
    salesActivityDetail: {},
    trips: [
      {
        id: 1,
        label: 'at office'
      },
      {
        id: 2,
        label: 'ddk'
      },
      {
        id: 3,
        label: 'dlk'
      },
      {
        id: 4,
        label: 'wfh'
      }
    ]
  }
}
